import { IconCheckmark } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled, { CSSProp } from 'styled-components';

export const DropdownOptionLabelStyled = styled.span`
  display: flex;
  align-items: center;
  gap: 1rem;
  text-transform: capitalize;
  font-size: 1.4rem;
  line-height: 2.4rem;
`;

export const OptionLabelStyled = styled.span<{ $isActive: boolean }>`
  margin-left: ${({ $isActive }): CSSProp => ($isActive ? 0 : '3rem')};
`;

export const ActiveSortingOptionIconStyled = styled(IconCheckmark)`
  flex-shrink: 0;
`;
